"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = KevelPLPBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const KevelPLPBanner_module_scss_1 = __importDefault(require("./KevelPLPBanner.module.scss"));
const sanitise_1 = require("../../utils/sanitise");
const breakpoints_1 = require("../../constants/breakpoints");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
function KevelPLPBanner({ associatedAdvertId, logoImage, logoAccessibilityText, title, ctaLink, ctaText, desktopImage, mobileImage, accessibilityText, description, backgroundColour, textColour, previewerSize, clickUrl, impressionUrl, }) {
    const TITLE_CHAR_LIMIT = 32;
    const DESC_CHAR_LIMIT = 102;
    const DEFAULT_TEXT_COLOUR = "#5B5B5B";
    const DEFAULT_BACKGROUND_COLOUR = "#F8F7F7";
    const color = (0, sanitise_1.sanitiseColor)(textColour !== null && textColour !== void 0 ? textColour : DEFAULT_TEXT_COLOUR);
    let bannerClassName = KevelPLPBanner_module_scss_1.default.banner;
    let contentClassName = KevelPLPBanner_module_scss_1.default.content;
    let headerClassName = KevelPLPBanner_module_scss_1.default.header;
    let textGroupClassName = KevelPLPBanner_module_scss_1.default.textGroup;
    let logoClassName = KevelPLPBanner_module_scss_1.default.logo;
    let titleClassName = KevelPLPBanner_module_scss_1.default.title;
    let descriptionClassName = KevelPLPBanner_module_scss_1.default.description;
    let ctaClassName = KevelPLPBanner_module_scss_1.default.cta;
    let imageContainerClassName = KevelPLPBanner_module_scss_1.default.imageContainer;
    if (previewerSize) {
        bannerClassName = KevelPLPBanner_module_scss_1.default[`preview-banner-${previewerSize}`];
        contentClassName = KevelPLPBanner_module_scss_1.default[`preview-content-${previewerSize}`];
        headerClassName = KevelPLPBanner_module_scss_1.default[`preview-header-${previewerSize}`];
        textGroupClassName = KevelPLPBanner_module_scss_1.default[`preview-textGroup-${previewerSize}`];
        logoClassName = KevelPLPBanner_module_scss_1.default[`preview-logo-${previewerSize}`];
        titleClassName = KevelPLPBanner_module_scss_1.default[`preview-title-${previewerSize}`];
        ctaClassName = KevelPLPBanner_module_scss_1.default[`preview-cta-${previewerSize}`];
        descriptionClassName = KevelPLPBanner_module_scss_1.default[`preview-description-${previewerSize}`];
        imageContainerClassName = KevelPLPBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`];
    }
    let linkOptions;
    if (previewerSize) {
        linkOptions = {
            target: ctaLink ? "_blank" : undefined,
            rel: ctaLink ? "noreferrer" : undefined,
            href: ctaLink ? ctaLink : undefined,
        };
    }
    else {
        linkOptions = { href: ctaLink !== null && ctaLink !== void 0 ? ctaLink : undefined };
    }
    return (react_1.default.createElement("a", Object.assign({ className: bannerClassName, "data-testid": "adtech-banner-esi", style: {
            backgroundColor: (0, sanitise_1.sanitiseColor)(backgroundColour !== null && backgroundColour !== void 0 ? backgroundColour : DEFAULT_BACKGROUND_COLOUR),
        } }, linkOptions, { onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        } }),
        react_1.default.createElement("div", { className: contentClassName },
            react_1.default.createElement("div", { className: headerClassName },
                (logoImage === null || logoImage === void 0 ? void 0 : logoImage.length) > 0 && (react_1.default.createElement("img", { "data-testid": "adtech-banner-logo", src: logoImage, className: logoClassName, alt: logoAccessibilityText })),
                react_1.default.createElement("div", { className: textGroupClassName },
                    react_1.default.createElement("p", { "data-testid": "adtech-banner-title", className: titleClassName, style: { color } }, title.substring(0, TITLE_CHAR_LIMIT)),
                    react_1.default.createElement("p", { "data-testid": "adtech-banner-description", className: descriptionClassName, style: { color } }, description === null || description === void 0 ? void 0 : description.substring(0, DESC_CHAR_LIMIT)))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", style: { color }, className: ctaClassName, labelText: ctaText, "data-testid": "adtech-banner-cta" }))),
        react_1.default.createElement("div", { className: imageContainerClassName },
            react_1.default.createElement("picture", null,
                react_1.default.createElement("source", { "data-testid": "adtech-banner-src-desktop", srcSet: desktopImage, media: `(min-width: ${breakpoints_1.desktop}px)` }),
                react_1.default.createElement("img", { "data-testid": "adtech-banner-image", src: mobileImage, className: KevelPLPBanner_module_scss_1.default.image, alt: accessibilityText })))));
}
